function roundQuantity(quantity) {
  if (quantity === null) {
    return null;
  }
  return Math.round(quantity * 10000 + Number.EPSILON) / 10000;
}

function transformUom(uom) {
  if (!uom) {
    return null;
  }
  return uom.toLowerCase();
}

export { roundQuantity, transformUom };
